import React, { Component } from 'react';
import { Form, FormGroup, FormControl, Button, InputGroup, Glyphicon } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';



class CheckRcRoRt extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.state = {
      value: ''
    };
  }

  handleKeyPress(ev) {
    if (ev.key === 'Enter') {
      ev.preventDefault()
      ev.stopPropagation();
      ev.nativeEvent.stopImmediatePropagation();
    }
  }
  handleChange(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    return (
      <div className="searchblock">
        Controleer een RC/RO/RT
        <Form>
          <FormGroup>
            <InputGroup>
              <FormControl type="text"
                value={this.state.value}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
              />
              <InputGroup.Button>
                <LinkContainer to={{
                  pathname: '/controleren/' + encodeURIComponent(this.state.value),
                  state: { message: this.state.value }
                }}><Button type="button"><Glyphicon glyph="search" /></Button></LinkContainer>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default CheckRcRoRt;


// WEBPACK FOOTER //
// ./src/components/Global/Modules/CheckRcRoRt.js